import React from 'react';
import { Route, Redirect } from 'react-router-dom';

export const PrivateRoute = ({ component: Component, ...rest }) => 
    (
    <Route {...rest} render={props => {
//        var cu = localStorage.getItem('companyUser');

//        if (typeof(cu)==='undefined' || cu===null) {
//            if (props.location.pathname.includes('/vendor/')) {
                return <Component {...props} />
//            }
//            return <Redirect to={{ pathname: '/login', state: { from: props.location } }}  /> 
//        }
/*
        else {
            var user = JSON.parse(cu);
            if (props.location.pathname!=='/pose' && user.role==='marker')
                return <Redirect to={{ pathname: '/pose', state: { from: props.location } }}  /> 
        }
        return <Component {...props} />
*/
/*
        (
        
        localStorage.getItem('companyUser')
            ? <Component {...props} />
            : <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
        )}} 
 */
    }}
/>
)